import { render } from "./MenuButton.vue?vue&type=template&id=70d955b6&scoped=true"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=70d955b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d955b6"]])

export default __exports__